import "./home-page.css";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
export default function AppAsporto() {

  return (
    <div className="home-pro">
<SEO
  title="Ordini Asporto Online per Ristoranti e Pizzerie | QrMenu Italia"
  description="QrMenu Italia aiuta ristoranti, pizzerie e locali a gestire l’asporto in modo più ordinato: ordini da smartphone, codice OTP, slot orari, notifiche al cliente e cucina collegata."
  canonical="https://qrmenu-italia.it/app-asporto"
  image="https://qrmenu-italia.it/og-asporto.jpg"
  keywords="ordini asporto online, app asporto ristorante, app asporto pizzeria, asporto con otp, menu asporto qr code, ordini da smartphone, gestione asporto ristorante"
/>

<MarketingNavbar />
      {/* HERO */}
            {/* HERO */}
<section className="hp-hero">
  <div className="hp-hero-noise"></div>
  <div className="hp-hero-glow"></div>

  <div className="hp-hero-inner">
    <div className="hp-hero-eyebrow">
      <span className="hp-dot"></span>
      ASPORTO PIÙ ORDINATO
    </div>

    <h1 className="hp-hero-h1">
      Meno telefonate confuse,
      <span className="hp-hero-accent">
        più controllo sugli ordini da asporto.
      </span>
    </h1>

    <p className="hp-hero-sub">
      Con QrMenu il cliente può ordinare dal telefono, verificare il numero
      con codice OTP, scegliere l’orario disponibile e ricevere aggiornamenti
      quando l’ordine è in preparazione o pronto per il ritiro.
    </p>

    <div className="hp-hero-pills">
      <span className="hp-pill">✦ Ordini da smartphone</span>
      <span className="hp-pill">✦ Verifica con codice OTP</span>
      <span className="hp-pill">✦ Slot orari configurabili</span>
      <span className="hp-pill">✦ Notifiche al cliente</span>
      <span className="hp-pill">✦ Ordini inviati subito in cucina</span>
    </div>

    <div className="hp-hero-actions">
      <a href="/demo" className="hp-btn-demo">
        Prova Gratis 7 Giorni
      </a>

      <a href="/contatti" className="hp-btn-ghost">
        Richiedi informazioni
      </a>
    </div>
  </div>

  <div className="hp-hero-mockup">
    <div className="hp-phone">
      <div className="hp-phone-notch"></div>

      <div className="hp-phone-screen">
        <div className="hp-screen-header">
          <div className="hp-screen-tag">
            ASPORTO
          </div>

          <div className="hp-screen-time">
            12:45
          </div>
        </div>

        <div className="hp-screen-category active">
          Pizze
        </div>

        <div className="hp-screen-item">
          <div className="hp-screen-item-img"></div>

          <div className="hp-screen-item-info">
            <div className="hp-screen-item-name">
              Pizza Margherita
            </div>

            <div className="hp-screen-item-price">
              €8.50
            </div>
          </div>

          <div className="hp-screen-item-add">
            +
          </div>
        </div>

        <div className="hp-screen-item">
          <div className="hp-screen-item-img alt"></div>

          <div className="hp-screen-item-info">
            <div className="hp-screen-item-name">
              Coca Cola
            </div>

            <div className="hp-screen-item-price">
              €3.00
            </div>
          </div>

          <div className="hp-screen-item-add">
            +
          </div>
        </div>

        <div className="hp-screen-ai">
          <span className="hp-screen-ai-dot"></span>
          Codice verificato • Ti avviseremo quando sarà pronto
        </div>
      </div>
    </div>
  </div>
</section>

           {/* SEO CONTENT */}
      <section className="hp-problem">

<div className="hp-problem-inner">
  <div className="hp-section-tag">
    Asporto senza caos
  </div>

  <h2 className="hp-section-h2">
    L’asporto funziona meglio quando ogni ordine arriva chiaro
  </h2>

  <p className="hp-seo-text">
    Telefonate, messaggi incompleti, orari confusi e clienti che chiedono
    “è pronto?” possono rendere l’asporto difficile da gestire, soprattutto
    nei momenti di punta.
  </p>

  <p className="hp-seo-text">
    QrMenu aiuta il locale a ricevere ordini da smartphone in modo più ordinato:
    il cliente sceglie i prodotti, conferma il numero con codice OTP e può ricevere
    aggiornamenti sullo stato dell’ordine.
  </p>

  <p className="hp-seo-text">
    Se il locale vuole, può configurare fasce orarie di ritiro per evitare troppi
    ordini nello stesso momento e organizzare meglio cucina e consegne al banco.
  </p>

  <p className="hp-seo-text">
    Anche qui il gestore resta libero: può decidere se attivare asporto, notifiche,
    verifica OTP, slot orari e collegamento con la cucina in base al proprio modo di lavorare.
  </p>
</div>

        {/* FEATURES */}
        <section className="hp-features">

          <div className="hp-section-tag">
  Cosa cambia per il locale
</div>

<h2 className="hp-section-h2">
  Un modo più semplice per ricevere e gestire gli ordini da asporto
</h2>

          <div className="hp-features-grid">

            <div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Ordini chiari dal telefono
  </h3>

  <p className="hp-feat-desc">
    Il cliente sceglie dal menu, aggiunge i prodotti al carrello e invia l’ordine
    senza telefonate lunghe o messaggi incompleti.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Numero verificato con OTP
  </h3>

  <p className="hp-feat-desc">
    Il codice OTP aiuta a verificare il numero del cliente prima dell’invio,
    rendendo l’ordine più affidabile per il locale.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Orari di ritiro più ordinati
  </h3>

  <p className="hp-feat-desc">
    Il locale può usare slot orari configurabili per distribuire meglio gli ordini
    ed evitare troppi ritiri nello stesso momento.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Cliente aggiornato
  </h3>

  <p className="hp-feat-desc">
    Il cliente può ricevere aggiornamenti quando l’ordine è in preparazione
    o pronto, riducendo chiamate e richieste continue.
  </p>
</div>

<div className="hp-feat-card hp-feat-card--featured">
  <h3 className="hp-feat-title">
    Cucina sempre informata
  </h3>

  <p className="hp-feat-desc">
    Gli ordini arrivano direttamente in cucina o al punto di gestione
    e, se configurata, può partire anche la stampa automatica della comanda.
  </p>
</div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">
    Nessuna app obbligatoria
  </h3>

  <p className="hp-feat-desc">
    Il cliente usa il servizio dal telefono senza scaricare app dagli store.
    Il locale può comunque offrire un’esperienza moderna e app-like.
  </p>
</div>

 
          </div>

        </section>

      </section>
{/* CTA */}
<section className="hp-final">
  <div className="hp-final-noise" />

  <div className="hp-final-inner">
    <h2 className="hp-final-h2">
      Vuoi rendere più semplice la gestione dell’asporto?
    </h2>

    <p className="hp-final-sub">
      Prova QrMenu e gestisci ordini, verifica OTP, slot orari,
      notifiche al cliente e cucina collegata in un unico sistema.
    </p>

    <div className="hp-hero-actions">
      <a href="/demo" className="hp-btn-demo">
        Prova Gratis 7 Giorni
      </a>

      <a href="/contatti" className="hp-btn-primary">
        Richiedi informazioni
      </a>
    </div>
  </div>
</section>
      <MarketingFooter />

    </div>
  );
}